import { forwardRef } from 'react';

// Use CSS-only animated background to avoid loading multiple images
const AnimatedBackground = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <div ref={ref} className="animated-bg" aria-hidden="true">
      {/* CSS-only floating elements - no images */}
      <div className="floating-shape shape-1" />
      <div className="floating-shape shape-2" />
      <div className="floating-shape shape-3" />
    </div>
  );
});

AnimatedBackground.displayName = 'AnimatedBackground';

export default AnimatedBackground;
